import apiClient from "./axios";
import { ApiResponse, AdminRoleSummary, AdminPermissionDef } from "../types";

export interface CreateRoleDto {
  name: string;
  description?: string;
  permissions: string[];
}

export interface UpdateRoleDto {
  name?: string;
  description?: string;
  permissions?: string[];
}

export const rolesApi = {
  getPermissions: async () => {
    const { data } = await apiClient.get<ApiResponse<AdminPermissionDef[]>>(
      "/admin/roles/permissions",
    );
    return data.data;
  },

  getRoles: async () => {
    const { data } =
      await apiClient.get<ApiResponse<AdminRoleSummary[]>>("/admin/roles");
    return data.data;
  },

  createRole: async (dto: CreateRoleDto) => {
    const { data } = await apiClient.post<ApiResponse<AdminRoleSummary>>(
      "/admin/roles",
      dto,
    );
    return data.data;
  },

  updateRole: async (id: string, dto: UpdateRoleDto) => {
    const { data } = await apiClient.patch<ApiResponse<AdminRoleSummary>>(
      `/admin/roles/${id}`,
      dto,
    );
    return data.data;
  },

  deleteRole: async (id: string) => {
    const { data } = await apiClient.delete<ApiResponse<{ message: string }>>(
      `/admin/roles/${id}`,
    );
    return data.data;
  },
};
